import Tool from './Tool';

// Stylus tools are always enabled.
class ToolStylus extends Tool {
  static enabled() {
    return true;
  }
}

export default ToolStylus;
